import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import LivestreamFeaturedProducts from '../LivestreamFeaturedProducts';
import LivestreamVideoPlayer from '../LivestreamVideoPlayer';
const LivestreamActiveVideo = t0 => {
  const $ = _c(32);
  const {
    category,
    description,
    isPlayingLive: t1,
    products: t2,
    title,
    videoId,
    videoType,
    isAdmin: t3
  } = t0;
  const isPlayingLive = t1 === undefined ? false : t1;
  let t4;
  if ($[0] !== t2) {
    t4 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const products = t4;
  const isAdmin = t3 === undefined ? false : t3;
  if (!videoId || !videoType) {
    return null;
  }
  const t5 = !products.length;
  let t6;
  if ($[2] !== t5 || $[3] !== videoId || $[4] !== videoType) {
    t6 = <LivestreamVideoPlayer videoId={videoId} videoType={videoType} fullWidth={t5} />;
    $[2] = t5;
    $[3] = videoId;
    $[4] = videoType;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== isAdmin || $[7] !== products) {
    t7 = !!products.length && <div className="ml-12 max-[1023px]:hidden"><LivestreamFeaturedProducts products={products} isAdmin={isAdmin} /></div>;
    $[6] = isAdmin;
    $[7] = products;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = <div className="flex">{t6}{t7}</div>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== isPlayingLive) {
    t9 = !!isPlayingLive && <div className="text-xs font-bold items-center text-red inline-flex mb-[5px]"><span className="text-2xl font-bold leading-[0] mr-px">•</span>LIVE</div>;
    $[12] = isPlayingLive;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== title) {
    t10 = !!title && <h1 className="text-3xl font-bold m-0 text-gray-dark">{title}</h1>;
    $[14] = title;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== category) {
    t11 = !!category && <div className="text-base font-bold text-gray-light2 mx-0 my-4">{category}</div>;
    $[16] = category;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== description) {
    t12 = <div className="text-base text-gray mx-0 my-4">{description}</div>;
    $[18] = description;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== t12 || $[23] !== t9) {
    t13 = <div className="mt-6 pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:pl-0 lg:pr-0">{t9}{t10}{t11}{t12}</div>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
    $[23] = t9;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== isAdmin || $[26] !== products) {
    t14 = !!products.length && <div className="lg:hidden"><LivestreamFeaturedProducts products={products} isAdmin={isAdmin} /></div>;
    $[25] = isAdmin;
    $[26] = products;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t13 || $[29] !== t14 || $[30] !== t8) {
    t15 = <div className="LivestreamActiveVideo">{t8}{t13}{t14}</div>;
    $[28] = t13;
    $[29] = t14;
    $[30] = t8;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  return t15;
};
LivestreamActiveVideo.propTypes = {
  category: PropTypes.string,
  description: PropTypes.string,
  isPlayingLive: PropTypes.bool,
  products: PropTypes.arrayOf(PropTypes.number),
  title: PropTypes.string,
  videoId: PropTypes.string,
  videoType: PropTypes.oneOf(['vimeo', 'wistia']),
  isAdmin: PropTypes.bool
};
export default LivestreamActiveVideo;